'use strict';

import Constants from '../constants.js';
import ObjectAssign from 'object-assign';

const initialState = {
    hydrated: false,
    loading: false,
    error: undefined,
    errorMessage: '',
    hasError: {},
    help: {},
    fieldKeys: [],
    invalidFieldKeys: {}

};
const reducer = function (state = initialState, action) {

    if (action.type === Constants.SUBMIT_LOCAL_FIELDS) {

        return ObjectAssign({}, state, {
            loading : false,
            hydrated : false,
            error: action.err,
            errorMessage: '',
            fieldKeys: [],
            invalidFieldKeys: {}
        });

    }

    if (action.type === Constants.SUBMIT_LOCAL_FIELDS_RESPONSE) {

        if ( !action.err) {
            return ObjectAssign({}, state, {
                loading: false,
                hydrated: true,
                error: undefined
            });
        }

        let errorMessage = '';
        let fieldKeys = [];
        let invalidFieldKeys = {};
        switch (action.err.code) {
            case 'LOCAL_FIELDS_FIELDS_INVALID':
                // occurs when certain fields do not pass client side validation
                errorMessage = 'Name on card is required';//when we actually have more fields we will need to check on what key
                invalidFieldKeys = action.err.invalidFieldKeys;
                break;
            default:
                errorMessage = 'Something bad happened!' +  action.err;
        }

        return ObjectAssign({}, state, {
            loading: false,
            hydrated: false,
            error : action.err,
            errorMessage,
            fieldKeys,
            invalidFieldKeys
        });
    }

    return state;
};


export default reducer;
